import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import creditoInteresService from '../../../service/administracion/creditoInteresService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            tipoCreditos: [],
            estados: estadoMock.values,
            filter: {
                nombre: "",
                idCredito: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idCredito: 0,
            credito: "",
            codigo: "",
            valor: 0,
            tipoCreditos: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombre: "",
            idCredito: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await creditoInteresService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Almacén.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await creditoInteresService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Almacén.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await creditoInteresService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await creditoInteresService.eliminar(values);
            else
                response = await creditoInteresService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(
                    <ul>
                        {response.data.messages.map((item) => (
                            <li>{item}</li>
                        ))}
                    </ul>
                );
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tipoCreditos = this.state.tipoCreditos;

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        this.setState({
            visible: true,
            formValues: {
                id: values.id,
                nombre: values.nombre,
                valor: values.valor,
                idCredito: values.idCredito,
                tipoCreditos: this.state.tipoCreditos,
            }
        });
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await creditoInteresService.registrar(values);
            else
                response = await creditoInteresService.modificar(values);

            if (response.status === 200) {

                const tipoCreditos = await creditoInteresService.listarTipoCredito();

                form.resetFields();
                this.setState({ visible: false, tipoCreditos });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    async componentDidMount() {
        this._initPagination(this.state.filter, creditoInteresService.paginacion);
        const tipoCreditos = await creditoInteresService.listarTipoCredito();

        this.setState({
            loadingSource: false,
            tipoCreditos: tipoCreditos ? tipoCreditos : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Tipo de Crédito"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    tipoCreditos={this.state.tipoCreditos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    //onExportExcel={this.handleExportExcel}
                    //onExportPdf={this.handleExportPdf}
                    //onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}